/**
 * Helper functon for returning the viewport width based on the outer width of the window provided
 * @param viewportWidth
 */
import { NUMBER_1440, NUMBER_768, NUMBER_968 } from '~shared/constants';

export function viewportSizeDetector(viewportWidth: number, plpBanner?: boolean) {
    if (viewportWidth >= NUMBER_1440) {
      return '1440';
    } else if (viewportWidth >= NUMBER_968) {
      return plpBanner ? '968' : '1024';
    } else if (viewportWidth >= NUMBER_768) {
      return '768';
    } else {
      return '375';
    }
  }
